import axios from './api';
import { getQueryData, getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/PreDeliveryNotes';

export const deletePreDeliveryNote = async ({ id }) => {
  return axios
    .delete(endPoint.concat(`/${id}`))
    .then((res) => res)
    .catch((error) => error.response);
};

export const listPreDeliveryNote = async ({ page, size, filters }) => {
  if (!filters.used) filters.used = false;
  if (!filters.docket_number) {
    delete filters.docket_number;
  }
  if (filters.used === 1) filters.used = true;
  if (filters.sortable?.includes('NONE')) delete filters.sortable;

  return axios
    .get(
      endPoint.concat(
        getQueryData(page, size, filters).replace('pid', 'project'),
      ),
      {
        timeout: 30000,
      },
    )
    .then((res) => res)
    .catch((error) => error.response);
};

export const updatePreDeliveryNote = async (body) => {
  return axios.put(endPoint.concat(`/${body.id}`), body).then((res) => res);
};
